// utils/resizeImage/resizeImageToBase64.utils.ts

/**
 * Alias MIME couramment rencontrés. Le picker iOS de react-native-image-picker
 * labellise les JPEG "image/jpg" (ImagePickerUtils.mm getFileType), qui n'est
 * pas le MIME canonique "image/jpeg".
 */
const MIME_ALIASES: Record<string, string> = {
    "image/jpg": "image/jpeg",
    "image/pjpeg": "image/jpeg",
    "image/x-png": "image/png",
};

/** Extrait le MIME canonique d'un data URL, ou null si l'entrée n'en est pas un. */
function getDataUrlMimeType(input: string): string | null {
    const match = /^data:([^;,]+)[;,]/.exec(input);
    if (!match) return null;
    const mime = match[1].trim().toLowerCase();
    return MIME_ALIASES[mime] ?? mime;
}

/** Réécrit l'en-tête du data URL avec le MIME canonique (ex: image/jpg → image/jpeg). */
export function canonicalizeDataUrl(input: string): string {
    const mime = getDataUrlMimeType(input);
    return mime ? input.replace(/^data:[^;,]+/, `data:${mime}`) : input;
}

/**
 * True si l'entrée est un data URL dont le format est décodable par le
 * resizer de la plateforme. Les URLs http(s) (avatar déjà hébergé) et les
 * formats non décodables sont retournés tels quels par les resizers.
 */
export function isSupportedForResize(
    input: string,
    supportedMimeTypes: readonly string[],
): boolean {
    const mime = getDataUrlMimeType(input);
    return mime !== null && supportedMimeTypes.includes(mime);
}
